import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { FieldRow, ProductPicker, QuantityStepper, RowThumb } from '../ui';
import { radius } from '../../themes/smartinventoryTheme';

// Create ("Add stock") picks a product via ProductPicker, then sets an
// initial quantity. Edit shows the fixed product and a QuantityStepper with
// the "Was 128 · +14" delta line. Both share the optional per-item
// low-stock threshold field (BACKEND.md §4 — blank keeps the global rule).
const InventoryFormDrawer = ({
  t, drawerMode, filteredProducts, productPickerId, setProductPickerId, productSearch, setProductSearch,
  pickedProduct, quantity, setQuantity, previousQuantity, lowStockThreshold, setLowStockThreshold, saving,
}) => (
  <>
    {drawerMode === 'create' ? (
      <FieldRow label={t('Product')} required>
        <ProductPicker
          products={filteredProducts.map((p) => ({
            id: p._id,
            name: p.productName,
            description: p.productDescription,
            price: p.productPrice != null ? `$${Number(p.productPrice).toFixed(2)}` : '',
            unit: p.unit,
            image: p.productImage,
          }))}
          value={productPickerId}
          onChange={setProductPickerId}
          searchValue={productSearch}
          onSearchChange={(e) => setProductSearch(e.target.value)}
          searchPlaceholder={t('Search Products')}
          emptyLabel={t('No products found matching your criteria')}
        />
      </FieldRow>
    ) : (
      <FieldRow label={t('Product')}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.25, border: '1px solid', borderColor: 'divider', borderRadius: `${radius.md}px` }}>
          <RowThumb src={pickedProduct?.productImage} name={pickedProduct?.productName} />
          <Typography variant="subtitle1" noWrap>{pickedProduct?.productName}</Typography>
        </Box>
      </FieldRow>
    )}

    <FieldRow label={t('Quantity')} required sx={{ mt: 2 }}>
      <QuantityStepper
        value={quantity}
        unit={pickedProduct?.unit}
        min={0}
        onChange={setQuantity}
        previousValue={previousQuantity}
        wasLabel={t('Was', { defaultValue: 'Was' })}
      />
    </FieldRow>

    <FieldRow
      label={t('Low stock threshold', { defaultValue: 'Low stock threshold' })}
      helper={t('Leave blank to use the default (10 units).', { defaultValue: 'Leave blank to use the default (10 units).' })}
    >
      <TextField
        fullWidth
        type="number"
        value={lowStockThreshold}
        onChange={(e) => setLowStockThreshold(e.target.value)}
        disabled={saving}
        placeholder="10"
      />
    </FieldRow>
  </>
);

export default InventoryFormDrawer;
